import CompaniesHome from '@/pages/companies/CompaniesHome'
import CreateCompany from '@/pages/companies/CreateCompany'
import EditCompany from '@/pages/companies/EditCompany'

const routes = [
  {
    path: '/companies/:parkId',
    name: 'CompaniesHome',
    component: CompaniesHome,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK']
    },
    props: true
  },
  {
    path: '/create-company/:parkId',
    name: 'CreateCompany',
    component: CreateCompany,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK']
    },
    props: true
  },
  {
    path: '/edit-company/:id',
    name: 'EditCompany',
    component: EditCompany,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK']
    },
    props: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/companies.js